export const APPEARANCE_STRINGS = Object.freeze({
  title: 'Chat Themes',
  unsavedChangesConfirmation: 'You have unsaved changes. Are you sure you want to leave and discard them?',
  saveSuccess: 'Theme saved successfully',
  generateFromWebsite: 'Generate from website',
  generateSuccess: 'Theme prefilled from your website. Review it and click Save to keep it.',
  generateEmpty: 'We could not find a brand colour, logo or name on that website. The theme was left unchanged.'
})

export const DEFAULT_APPEARANCE_JSON = Object.freeze(
  {
    header: {
      bg: 'linear-gradient(70.77deg, #6e40ff 38%, #2f8fff)',
      fontSize: '20px',
      text: '#fff',
      padding: '8px',
      logoOnly: false,
      showWideViewButton: false,
      showModalViewButton: false,
      logoUrl: 'https://amio-testing.s3.eu-central-1.amazonaws.com/amio_logo.png',
      closeBtn: {
        color: '#fff'
      }
    },
    launcher: {
      bg: 'linear-gradient(70.77deg, #6e40ff 38%, #2f8fff)',
      forceFullScreen: false
    },
    messageBubble: {
      fontSize: '14px',
      fontWeight: 300,
      lineHeight: 1.2,
      paddingText: '10px 20px',
      paddingStruct: '20px 20px 15px 20px',
      width: '85%'
    },
    messageList: {
      bg: '#fff'
    },
    sentMessage: {
      wrapperBg: '#fff',
      bg: '#6E40FF',
      text: '#fff',
      button: {
        bg: '#6E40FF',
        bgHover: 'rgba(110, 64, 255, 0.75)',
        border: 'none',
        text: '#fff',
        textHover: '#fff'
      },
      carouselButton: {
        text: '#6E40FF',
        textHover: '#fff',
        bgHover: '#6E40FF'
      },
      qr: {
        borderColor: '#6E40FF',
        text: '#6E40FF',
        bg: 'white',
        bgHover: '#6E40FF',
        borderColorHover: '#fff',
        textHover: '#fff'
      },
      file: {
        bg: 'rgba(110, 64, 255, 0.15)',
        text: '#6E40FF',
        border: '#6E40FF'
      }
    },
    receivedMessage: {
      bg: '#eaeaea',
      marginRight: '0px',
      text: '#222222',
      file: {
        bg: '#eaeaea',
        text: '#222222',
        border: '#222222'
      }
    },
    userInput: {
      wrapperBg: '#fff',
      bg: '#f4f7f9',
      text: '#565867',
      sendIcon: '#ffffff',
      sendButton: '#6E40FF'
    },
    statusInfo: {
      bg: '#9a80ee',
      text: '#fff'
    },
    font: 'Golos Text, sans-serif'
  }
)

export const DEFAULT_LANG_CONFIG = Object.freeze({
  default: {
    welcome: 'Company name',
    buttonTitle: ''
  }
})

export const DEFAULT_THEME = Object.freeze({
  name: 'Default',
  themeConfig: DEFAULT_APPEARANCE_JSON,
  langConfig: DEFAULT_LANG_CONFIG
})

export const CHAT_ELEMENTS = Object.freeze({
  buttons: 'Buttons',
  quickReplies: 'Quick replies',
  carousel: 'Carousel',
  fileAttachment: 'File attachment',
  clientInput: 'Client input'
})

export const AMIO_DEMO_CHAT_URL = 'https://demo.amio.io'
